
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import dynamic from "next/dynamic"
import Head from "next/head"

import useCartStore from "@/store/slices/cart"
import Default from "@/templates/Default"

const CartView = dynamic(() => import("@/views/cart"), { ssr: false })
const Placeholder = dynamic(() => import("@/views/cart/includes/Placeholder"), {
  ssr: false,
})

// TODO: Handle storage sync between multiple tabs

function CartPage() {
  const { products } = useCartStore((state) => state)

  if (!products || products.length <= 0) {
    return <Placeholder />
  }

  return (
    <>
      <Head>
        <title>Koszyk | fansi.pl</title>
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <CartView products={products} />
    </>
  )
}

CartPage.Layout = Default

export default CartPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cart',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  